import builder from '../builder';
import ArrowButtonDown from '../../streamline-icons/bold/arrow-button-down.svg';
export default builder('IconArrowButtonDownBold', ArrowButtonDown);
//# sourceMappingURL=ArrowButtonDown.js.map